window.addEventListener('load', () => {
  let slideItem = new Swiper('.slide-wrap', {
    initialSlide: 0,
    loop: false,
    speed: 600,
    centeredSlides: false,
    slidesPerView:3,
    slidesPerGroup: 3,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: 'true',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  let slideLength = Math.round((slideItem.slides.length)/3)
  document.getElementsByClassName('slide-length')[0].innerHTML ='<span class="slide-length">' + slideLength + '</span>';
  slideItem.on('slideChange', function(){
    let currentSlide = slideItem.realIndex
    if (currentSlide < 3) {
      currentSlider = 0
    } else {
      currentSlider = Math.round(currentSlide / 3)
    }
    document.getElementsByClassName('slide-current')[0].innerHTML ='<span class="slide-current">' + (currentSlider + 1) + '</span>';
  })



  // ONLY  /cart/index.php - - - - - - - - - - - - - - - - - - - - - - - -
  if (document.getElementsByClassName('calender-foundation')[0] !=null && document.getElementsByClassName('change-days')[0] != null) {

    const modalContent = document.getElementsByClassName('calender-foundation')[0]
    document.getElementsByClassName('change-days')[0].onclick = () => {
      document.getElementsByClassName('calender-foundation')[0].classList.add('standby')

      setTimeout(() => {
        document.getElementsByClassName('calender-wrap')[0].classList.add('active')
      }, 600);
    } //onclick

    // close button.
    document.getElementsByClassName('close-calender')[0].onclick = () => {
      document.getElementsByClassName('calender-foundation')[0].classList.add('processing')
      document.getElementsByClassName('calender-wrap')[0].classList.remove('active')
      setTimeout(() => {
        document.getElementsByClassName('calender-foundation')[0].classList.remove('standby')
        document.getElementsByClassName('calender-foundation')[0].classList.remove('processing')
      }, 600);
    }

    // 日付確定後の処理
    document.getElementsByClassName('js-comfirm')[0].onclick = () => {
      const arry = []
      let checkDay = document.getElementsByName('days')
      for (let i = 0; i < checkDay.length; i++) {
        if (checkDay[i].checked) {
          arry.push(checkDay[i].value)
        }
      }

      let year = document.getElementsByClassName('current-year')[0].innerText
      let month = document.getElementsByClassName('current-month')[0].innerText
      let jsMonth = document.getElementsByClassName('current-month')[0].innerText  - 1
      let days = arry[0]
      let dayOfWeekStrJP = [ "日", "月", "火", "水", "木", "金", "土" ]
      let date = new Date( year, jsMonth , days );

      if(days !== undefined) {
        document.getElementsByClassName('rental-start')[0].innerText = year + '/' + month + '/' + days + '(' + dayOfWeekStrJP[date.getDay()] + ')'
      }

      // close popup.
      document.getElementsByClassName('calender-foundation')[0].classList.add('processing')
      document.getElementsByClassName('calender-wrap')[0].classList.remove('active')
      setTimeout(() => {
        document.getElementsByClassName('calender-foundation')[0].classList.remove('standby')
        document.getElementsByClassName('calender-foundation')[0].classList.remove('processing')
      }, 600);
    } //onclick
  } //find calender

  // calender end foundation
  if (document.getElementsByClassName('calender-end-foundation')[0] !=null && document.getElementsByClassName('change-end-days')[0] != null) {
    const modalContent = document.getElementsByClassName('calender-end-foundation')[0]
    // console.log('done');
    document.getElementsByClassName('change-end-days')[0].onclick = () => {
      document.getElementsByClassName('calender-end-foundation')[0].classList.add('standby')

      setTimeout(() => {
        document.getElementsByClassName('calender-wrap')[0].classList.add('active')
      }, 600);
    } //onclick

    // close button.
    document.getElementsByClassName('close-calender')[1].onclick = () => {
      document.getElementsByClassName('calender-end-foundation')[0].classList.add('processing')
      document.getElementsByClassName('calender-wrap')[1].classList.remove('active')
      setTimeout(() => {
        document.getElementsByClassName('calender-end-foundation')[0].classList.remove('standby')
        document.getElementsByClassName('calender-end-foundation')[0].classList.remove('processing')
      }, 600);
    }

    // 日付確定後の処理
    document.getElementsByClassName('js-comfirm')[1].onclick = () => {
      const endarry = []
      let checkDay = document.getElementsByName('end-days')
      for (let endDay = 0; endDay < checkDay.length; endDay++) {
        if (checkDay[endDay].checked) {
          endarry.push(checkDay[endDay].value)
        }
      }

      let year = document.getElementsByClassName('end-year')[0].innerText
      let month = document.getElementsByClassName('end-month')[0].innerText
      let jsMonth = document.getElementsByClassName('end-month')[0].innerText  - 1
      let days = endarry[0]
      let dayOfWeekStrJP = [ "日", "月", "火", "水", "木", "金", "土" ]
      let date = new Date( year, jsMonth , days );

      if(days !== undefined) {
        document.getElementsByClassName('rental-end')[0].innerText = year + '/' + month + '/' + days + '(' + dayOfWeekStrJP[date.getDay()] + ')'
      }

      // close popup.
      document.getElementsByClassName('calender-end-foundation')[0].classList.add('processing')
      document.getElementsByClassName('calender-wrap')[1].classList.remove('active')
      setTimeout(() => {
        document.getElementsByClassName('calender-end-foundation')[0].classList.remove('standby')
        document.getElementsByClassName('calender-end-foundation')[0].classList.remove('processing')
      }, 600);
    } //onclick
  } //find calender

  //find cartpage.

  if (document.getElementsByClassName('content-wrap')[0].classList.contains('cart') == true && window.matchMedia('(max-width: 768px)').matches) {
    let calHeight = document.getElementsByClassName('content-wrap')[0].getBoundingClientRect().height -document.getElementById('cart-information').getBoundingClientRect().height
    document.getElementsByClassName('content-wrap')[0].style.height = calHeight + 'px'
  }
  // END ONLY  /cart/index.php - - - - - - - - - - - - - - - - - - - - - -
}) // onload
